import React, { useState } from "react";
import { ChevronLeftIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

const ResultCard = ({
  title = "",
  subtitle = "",
  content = () => {},
  active,
  onBack = () => {},
}) => {
  // State to handle content visibility for non-active cards
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`flex flex-col rounded-[20px] p-[20px] transition-colors duration-300 ${
        active
          ? "border-REELTeal border-solid border-[6px]"
          : "border-[6px] border-teal-75"
      }`}
    >
      <div className="flex flex-col bg-white rounded-[12px] py-[48px] px-[20px] shadow-custom relative min-h-[437px]">
        {active && (
          <div className="absolute left-[50%] top-[-40px] rounded-[20px] transform -translate-x-1/2 bg-REELTeal flex items-center justify-center p-[20px]">
            <p className="text-white font-bold text-[20px] leading-[20px]">
              My Result
            </p>
          </div>
        )}

        <p className="text-REELTeal text-display-xs text-center font-bold pb-4 border-b-[1px] border-b-gray-100">
          {title}
        </p>
        <p className="text-gray-800 font-semibold text-[20px] leading-[30px] mt-[18px]">
          {subtitle}
        </p>

        {!active && (
          <div className={`relative flex flex-col p-[10px] bg-gray-20 mt-[10px] rounded-[10px] ${isOpen ? 'min-h-[200px]': ''}`}>
            <button
              className="text-body-md text-gray-800 text-left flex items-center justify-between w-full"
              onClick={() => setIsOpen(!isOpen)}
            >
              {!isOpen ? "Result Details" : ""}
              <ChevronDownIcon
                className={`w-[20px] text-gray-800 ml-auto transform transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            {/* Conditionally render content if isOpen is true */}
            {isOpen && content()}
          </div>
        )}

        {/* For active card, always display content */}
        {active && (
          <div className="relative flex flex-col p-[10px] bg-gray-20 mt-[10px] rounded-[10px] min-h-[200px]">
            {content()}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultCard;
